import { React, useEffect, useState } from 'react'
import Link from 'next/link'
import CurrencyFormat from 'react-currency-format'
import Image from 'next/image'

import MiniCartItem from './minicartitem'

import { useSelector, useDispatch } from 'react-redux';
import { toggleCart } from '../../redux/minicart.slice';

import { addToCart } from '../../redux/cart.slice';
import { clearCart } from '../../redux/cart.slice';

// import * as ga from '../../lib/ga'

function MiniCart() {

    const cart = useSelector((state) => state.cart);
    const user = useSelector((state) => state.user);
    const [isCartValidate, setIsCartValidate] = useState(null);
    const [isCartValidateMerchant, setIsCartValidateMerchant] = useState(null);

    var token = false
    var excluded_from_ordering = false
    if (user[0] != undefined) {
        token = user[0].token
        excluded_from_ordering = user[0].excluded_from_ordering
    }

    const get_inc_vat_total = () => {
        return cart.reduce(
            (accumulator, item) => accumulator + item.quantity * item.price_inc_vat,
            0
        );
    };
    const get_ex_vat_total = () => {
        return cart.reduce(
            (accumulator, item) => accumulator + item.quantity * item.price_ex_vat,
            0
        );
    };

    const minicart = useSelector((state) => state.minicart.minicart);
    const dispatch = useDispatch();

    const toggle_cart = () => {
        dispatch(toggleCart())
    }

    // useEffect(() => {
    //     ga.view_cart(cart)
    // });


    useEffect(() => {
        const api_call_basket_validate = async () => {
            if (isCartValidate === null) {
                fetch(
                    process.env.NEXT_PUBLIC_API_URL + '/validate_cart',
                    {
                        body: JSON.stringify({
                            cart: cart
                        }),
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: 'POST'
                    }
                )
                    .then(response => {
                        // reject not ok response
                        if (!response.ok) {
                            return Promise.reject(response)
                        }
                        return response.json()
                    })
                    .catch(async response => {
                        const error = await response.json().then(text => text)
                        return Promise.reject(error)
                    })
                    .then(data => {
                        if (data.status === true) {
                            setIsCartValidate(true);
                            dispatch(clearCart())
                            data.cart.forEach(element => {
                                dispatch(addToCart(element))
                            });
                        }
                    })
                    .catch((error) => {
                        console.warn(error)
                    });
            }
        }

        const merchant_api_call_basket_validate = async () => {
            if (isCartValidateMerchant === null) {
                const res = fetch(
                    process.env.NEXT_PUBLIC_API_URL + '/validate_cart_merchant',
                    {
                        body: JSON.stringify({
                            cart: cart,
                            device_name: 'browser'
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + token
                        },
                        method: 'POST'
                    }
                )

                    .then(response => {
                        // reject not ok response
                        if (!response.ok) {
                            return Promise.reject(response)
                        }
                        return response.json() // or return response.text()
                    })
                    .catch(async response => {
                        if (!response.ok && response.redirected) {
                            set_error('You have logged in on another device, please login again to see pricing')
                        }
                        const error = await response.json().then(text => text)
                        return Promise.reject(error)
                    })
                    .then(data => {
                        // herre I need to overwrite the product that we are using with the new data
                        if (data.status === true) {
                            setIsCartValidateMerchant(true);
                            dispatch(clearCart())
                            data.cart.forEach(element => {
                                dispatch(addToCart(element))
                            });
                        }
                    })
                    .catch((error) => {
                        console.warn(error);
                    });
            }
        }

        var token = false
        var merchant = false
        if (user[0] != undefined) {
            token = user[0].token
            if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
                merchant = true
            }
        }

        if (cart.length > 0) {
            if (merchant) {
                // re fetch data for their specific needs
                merchant_api_call_basket_validate()
            } else {
                api_call_basket_validate()
            }
        }

    });

    return (
        (minicart) ? (
            <>
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 bottom-0 flex justify-end" id="trolleyOverlay">
                    <div onClick={() => toggle_cart()} className="bg-gray-900 opacity-60 absolute top-0 left-0 right-0 bottom-0"></div>
                    <div className="w-full md:w-1/2 lg:w-1/4 bg-white relative z-50 flex flex-col">
                        <div className="w-full flex items-center py-6 text-center border-b border-gray-200 relative">
                            <h5 className="w-full leading-none mx-auto">My Trolley</h5>
                            <button type="button" className="absolute right-1 p-4 text-gray-900 rounded hover:text-brand-secondary active:text-brand-primary focus:ring focus:ring-brand-tertiary transition duration-150 ease-in-out" onClick={() => toggle_cart()}>
                                <svg className="stroke-current text-gray-900 hover:text-brand-secondary active:text-brand-primary transition duration-150 ease-in-out" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <g>
                                        <line x1="4" x2="20" y1="4" y2="20" fill="none" strokeLinecap="round" strokeWidth="2" />
                                        <line x1="20" x2="4" y1="4" y2="20" fill="none" strokeLinecap="round" strokeWidth="2" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <div className="space-y-6 flex-grow overflow-auto px-4 py-4 lg:px-5 lg:py-8">
                            {cart.length === 0 ? (
                                <div className="text-center">
                                    <Image
                                        src="/assets/images/illustrations/empty-trolley-illustration.svg"
                                        alt="Empty trolley illustration"
                                        width="166"
                                        height="200"
                                        className=""
                                        placeholder="blur"

                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                    />
                                    <p className="text-lg">Your Trolley is Empty!</p>
                                </div>
                            ) : (
                                <>
                                    {cart.map((item) => (
                                        <MiniCartItem key={item.id} item={item} type="cart"></MiniCartItem>
                                    ))}
                                </>
                            )}

                        </div>
                        <div className="flex-grow-0 border-t border-gray-200 p-4 lg:p-8">
                            <div className="space-y-4 mb-4 leading-none">
                                <div className="flex justify-between items-end">
                                    <div className="text-xl font-bold text-gray-900">Subtotal</div>
                                    <div className="text-lg text-gray-900 flex text-right">
                                        <span className="mr-4 font-medium flex flex-col"><CurrencyFormat decimalScale={2} value={get_ex_vat_total() / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} /> <span className="uppercase text-gray-500 font-medium text-xxs xl:ml-1">(ex. VAT)</span></span>
                                        <span className="flex font-bold flex-col"><CurrencyFormat decimalScale={2} value={get_inc_vat_total() / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} /> <span className="uppercase text-gray-500 font-medium text-xxs xl:ml-1">(inc. VAT)</span></span>
                                    </div>
                                </div>
                                {(excluded_from_ordering) ? ('') : (
                                    <div className="flex justify-between items-end">
                                        <div className="text-xl font-bold text-gray-900">Shipping</div>
                                        <div className="text-sm font-normal text-gray-600">Calculated at shipping step.</div>
                                    </div>
                                )}
                            </div>


                            {(excluded_from_ordering) ? (
                                <>
                                    <p>You have been excluded from placing orders by your HO. If this has been done in error, please contact <a href="mailto:marketing@advancedwater.co.uk">marketing@advancedwater.co.uk</a></p>
                                </>
                            ) : (
                                cart.length === 0 ? (
                                    <button className="btn btn-disabled btn-block btn-lg">Your Trolley is Empty!</button>
                                ) : (
                                    <Link href="/cart">
                                        <a className="btn btn-primary btn-lg btn-block" onClick={() => toggle_cart()}>Checkout</a>
                                    </Link>
                                )
                            )}


                        </div>
                    </div>
                </div >
            </>
        ) : (<></>)
    );
}

export default MiniCart;


